import React from 'react';
import type { GuidelineDiffHunk } from '../types/guidelineProposal';
import './GuidelineDiffBlock.css';

interface GuidelineDiffBlockProps {
  hunk: GuidelineDiffHunk;
}

function DiffLine({
  lineNo,
  kind,
  text,
}: {
  lineNo: number | null;
  kind: 'context' | 'remove' | 'add';
  text: string;
}) {
  const prefix =
    kind === 'remove' ? '−' : kind === 'add' ? '+' : ' ';
  return (
    <div className={`guideline-diff-line guideline-diff-line-${kind}`}>
      <span className="guideline-diff-gutter">{lineNo ?? ''}</span>
      <span className="guideline-diff-prefix">{prefix}</span>
      <span className="guideline-diff-text">{text || ' '}</span>
    </div>
  );
}

const GuidelineDiffBlock: React.FC<GuidelineDiffBlockProps> = ({ hunk }) => {
  let line = hunk.startLine;

  return (
    <div className="guideline-diff-block">
      <div className="guideline-diff-block-header">
        <code className="guideline-diff-path">{hunk.pathLabel}</code>
        <span className="guideline-diff-field">{hunk.fieldLabel}</span>
      </div>
      <div className="guideline-diff-file" role="group" aria-label={hunk.pathLabel}>
        {hunk.contextBefore.map((text) => {
          const current = line++;
          return <DiffLine key={`b-${current}`} lineNo={current} kind="context" text={text} />;
        })}
        {hunk.removed.map((text) => {
          const current = line++;
          return <DiffLine key={`r-${current}`} lineNo={current} kind="remove" text={text} />;
        })}
        {hunk.added.map((text) => {
          const current = line++;
          return <DiffLine key={`a-${current}`} lineNo={current} kind="add" text={text} />;
        })}
        {hunk.contextAfter.map((text) => {
          const current = line++;
          return <DiffLine key={`f-${current}`} lineNo={current} kind="context" text={text} />;
        })}
      </div>
      <p className="guideline-diff-rationale">{hunk.rationale}</p>
    </div>
  );
};

export default GuidelineDiffBlock;
